export type {
  DateRangePreset,
} from '../../sales/public-api';
export {
  DATE_RANGE_PRESETS,
  POS_SALES_HISTORY_DATE_PRESETS,
  DATE_RANGE_PRESET_LABELS,
} from '../../sales/public-api';

/** Pestañas principales del módulo Informes. */
export type ReportsSection = 'resumen' | 'ventas' | 'personal' | 'operacion' | 'compras' | 'agenda';

export const REPORTS_SECTIONS = ['resumen', 'ventas', 'personal', 'operacion', 'compras', 'agenda'] as const;

/** Mismo criterio que la tabla de ventas por producto: por debajo, layout de tarjetas densas. */
export const REPORTS_COMPACT_LAYOUT_MAX_WIDTH = 720;

/** Tamaño de página de listados en Informes (ventas por producto, ranking por operador). */
export const REPORTS_INFORMES_LIST_PAGE_SIZE = 10;

export const REPORTS_SECTION_LABELS: Record<ReportsSection, string> = {
  resumen: 'Resumen',
  ventas: 'Ventas',
  personal: 'Personal',
  operacion: 'Operación',
  compras: 'Compras',
  agenda: 'Agenda',
};

export const REPORTS_SECTION_ACCESSIBILITY: Record<ReportsSection, string> = {
  resumen: 'Resumen',
  ventas: 'Ventas',
  personal: 'Personal',
  operacion: 'Operación',
  compras: 'Compras',
  agenda: 'Agenda',
};

export const STOCK_SALE_POLICY_OPTIONS = [
  { id: 'block' as const, label: 'Bloquear' },
  { id: 'warn' as const, label: 'Advertir' },
  { id: 'allow' as const, label: 'Permitir' },
] as const;

export const REPORTS_SERVICE_TYPE_OPTIONS = ['carga_virtual', 'sube'] as const;
